import { styled, useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement } from 'react';
import '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';

const _excluded = ["theme"];
var ChipWrapper = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    bg: theme.palette.grey[20],
    width: 'fit-content',
    p: `${theme.spacing.xxs}px ${theme.spacing.sm}px`,
    mb: `${theme.spacing.xxs}px`,
    borderRadius: `${theme.shape.borderRadius}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }, rest);
})``;

const Chip = ({
  renderContent,
  label,
  styles = {},
  onRemove
}) => {
  var _styles$closeButton;
  const theme = useTheme();
  return /*#__PURE__*/createElement(ChipWrapper, styles.wrapper, /*#__PURE__*/createElement(Div, _extends({
    display: "flex"
  }, styles.text), label || renderContent && renderContent() || ''), !!onRemove && /*#__PURE__*/createElement(Button, {
    iconOnly: true,
    iconProps: {
      glyph: icons.CLOSE,
      size: 16
    },
    onClick: onRemove,
    styles: _objectSpread2(_objectSpread2({}, styles.closeButton), {}, {
      root: _objectSpread2({
        p: 0,
        display: 'flex!important',
        ml: `${theme.spacing.xxs}px`
      }, (_styles$closeButton = styles.closeButton) === null || _styles$closeButton === void 0 ? void 0 : _styles$closeButton.root)
    })
  }));
};

export default Chip;
